import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Button, { ILink } from 'tbk-components/src/components/Button';

export interface IAntennaSelectionNextStepsProps extends IBaseElementProps {
	backLink?: ILink;
	nextStepButton?: ILink;
	nextStepText?: string;
	current?: number;
	updateCurrent?: (increase: boolean) => void;
}

const AntennaSelectionNextSteps: React.FC<IAntennaSelectionNextStepsProps> = ({
	nextStepButton,
	nextStepText,
	backLink,
	current,
	updateCurrent,
	className,
	classNames = [],
}) => (
	<div
		className={
			className || cn('antenna-selection-next-steps', ...classNames)
		}
	>
		<div className="antenna-selection-next-steps__container">
			{backLink && current > 0 && (
				<Button
					className="antenna-selection-next-steps__back text-decoration-none d-inline-flex align-items-center"
					onClick={() => {
						updateCurrent(false);
					}}
				>
					<span className="icon icon-arrow-left"></span>
					{backLink.label}
				</Button>
			)}

			<div className="antenna-selection-next-steps__upcoming-step">
				{nextStepText && <p className="subheading">{nextStepText}</p>}
				{nextStepButton && (
					<Button
						className="btn btn-primary"
						{...nextStepButton}
						onClick={() => {
							updateCurrent(true);
						}}
					>
						<span className="icon icon-arrow-right"></span>
					</Button>
				)}
			</div>
		</div>
	</div>
);

export default AntennaSelectionNextSteps;
